var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgAlertTriangle = function SvgAlertTriangle(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M1.866 20.5 12 3l10.135 17.5zM4.45 19h15.1L12 6zm8.123-1.427a.78.78 0 0 0 .235-.573.78.78 0 0 0-.235-.573.78.78 0 0 0-.573-.235.78.78 0 0 0-.573.235.78.78 0 0 0-.234.573q0 .339.234.573a.78.78 0 0 0 .573.235.78.78 0 0 0 .573-.235m-1.323-2.38h1.5v-5h-1.5z"
  })));
};
export default SvgAlertTriangle;